import { transitionFauluLoanCalculatorForm } from "../../../actions/fauluLoanCalculator/fauluLoanCalculatorForm";
import { FIELD_STATUS } from "../../../reducers/status";
import { getFauluLoanCalculatorForm } from "../../../selectors/fauluLoanCalculator/fauluLoanCalculator";

export const fauluLoanCalculatorFormRules = (store, next, action) => {
    const result = next(action);
    const fauluLoanCalculatorForm = getFauluLoanCalculatorForm(store.getState());
    const fauluLoanCalculatorValid = validateFormDetails(fauluLoanCalculatorForm);

    const formAction = fauluLoanCalculatorValid
            ? transitionFauluLoanCalculatorForm.formValid()
            : transitionFauluLoanCalculatorForm.formInvalid();
    
    store.dispatch(formAction);

    return result;
}

const validateFormDetails = formFields => (
    formFields.amount && formFields.amount.status === FIELD_STATUS.VALID &&
    formFields.interest && formFields.interest.status === FIELD_STATUS.VALID &&
    formFields.repaymentDuration && formFields.repaymentDuration.status === FIELD_STATUS.VALID &&
    formFields.duration && formFields.duration.status === FIELD_STATUS.VALID
);